module.exports = __webpack_public_path__ + "media/tower-video.32bc9981.mp4";